import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=f42c4904&scoped=true&"
import script from "./Timestamp.vue?vue&type=script&lang=ts&"
export * from "./Timestamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42c4904",
  null
  
)

export default component.exports